export class signinMfaFormInfo {
  constructor(authenticationCode) {
    this.authenticationCode = authenticationCode;
  }
}
export class signinResetApplyFormInfo {
  constructor(companyId, userId) {
    this.userId = userId;
    this.companyId = companyId;
  }
}
export class signinResetPasswordFormInfo {
  constructor(authenticationCode, newPassword, reNewPassword) {
    this.authenticationCode = authenticationCode;
    this.newPassword = newPassword;
    this.reNewPassword = reNewPassword;
  }
}
export class signinUseridApplyFormInfo {
  constructor(emailAddress) {
    this.emailAddress = emailAddress;
  }
}
